import React from 'react';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { Skeleton } from 'antd';
import { ExtensionsContextProvider } from '../context/ExtensionContext';

const AsyncUserMenu = React.lazy(() => import('../components/UserMenu'));
export const AsyncLazyUserMenu: React.FC<{ piletApi: PiletApi }> = ({ piletApi }) => (
	<React.Suspense fallback={<Skeleton.Avatar active size={44} shape="circle" />}>
		<ExtensionsContextProvider piletApi={piletApi}>
			<AsyncUserMenu />
		</ExtensionsContextProvider>
	</React.Suspense>
);
